var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('z-badge',{staticClass:"service-type-badge",style:({ backgroundColor: _vm.backgroundColor }),attrs:{"data-test-id":"content"}},[_vm._v(" "+_vm._s(_vm.displayContent)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }